import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { OLD_PRICE, PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/judo';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-220" data-mp="1mm7gao7xoxb7">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-221" data-mp="1hpqsxw8k6mz6">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-222" data-mp="tzwghfs5j0fg">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-223" data-mp="u0obaodxcu4o">
            Poznaj swój kompletny pakiet <em className="text-red-300" data-id="element-224" data-mp="13xkc07xl0byo">JUDO GOTOWE™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-225" data-mp="13uofmo1dtvcc">
            Cały sezon judo dla dzieci – gotowy. Na macie z planem w 5 minut.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-226" data-mp="2famw3cyw3jnl" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-227" data-mp="pk7gbmti0n9z">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-228" data-mp="ui0kkab8r77m">Kompletny pakiet zawiera</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-229" data-mp="zjg8ca4szrtp">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-230" data-mp="13iowmzh2qxhv">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-231" data-mp="6u97h4hvmq5a">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-232" data-mp="btvn1kl6gih9" />
                </span>
                <span data-id="element-233" data-mp="fsuogv7p9x3y">
                  <span className="block font-medium leading-snug" data-id="element-234" data-mp="fsb5rca874ov">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-235" data-mp="kmfcbufkxapf">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-236" data-mp="3o9fo3lefzdue">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-237" data-mp="vdnxorfz47at">
              Cena wprowadzająca{' '}
              <span className="sr-only" data-id="element-238" data-mp="qete3na6mepn">– cena regularna: </span>
              <s className="ml-1 font-serif text-xl text-slate-900/50" data-id="element-239" data-mp="1550pxk5oozhd">{OLD_PRICE}</s>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-240" data-mp="106z5ausm0s3s">
              <span className="sr-only" data-id="element-241" data-mp="chej8315teqa">Cena teraz: </span>
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-242" data-mp="7jwbgfyvp5jv">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-243" data-mp="lf866nd1aw0s" />
            Jednorazowa płatność. Bez subskrypcji.
          </p>

          <CtaButton label="Zamów cały pakiet teraz" className="mt-8 w-full" data-id="element-244" data-mp="1ww6qg1pbgz76" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-245" data-mp="1svejxg7tx8el">
            {offerIncludes.map(item => <li key={item} data-id="element-246" data-mp="20dm503ab6o3z">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}